module.exports = __webpack_public_path__ + "static/img/thumb-04.7e1ca82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/thumb/thumb-04.png
// module id = mN0V
// module chunks = 31